export const TOKEN = "token";
export const USERNAME = "username";
export const STATUS_GAME = "statusGame";
